import React from 'react';
import { useTranslation } from 'react-i18next';

import PageTitle from '../../shared-components/page-title/PageTitle';

import AlertList from './components/AlertsList';

/**
 *  function component
 */
function Alerts() {
  const { t } = useTranslation("alerts");

  return (
    <div>
      <div>
        <PageTitle title={t("alertsTitle")} />
      </div>
      {/* Content based on tab */}
      <div className="content">
        <AlertList />
      </div>
    </div>
  );
}

export default Alerts;
